module.exports = __webpack_public_path__ + "img/MK.8c63b34c.png";